import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { useAuth } from '../../../shared/AuthContext';






import NotFoundPage from '../../../pages/NotFoundPage';









const Factory = ( { model, children } ) => {

  const location = useLocation();

  const { isAuthenticated, loadingSession, user } = useAuth();

  const Service = {

    getDomain: () => {
      const result = {};

      model.modules.domain.forEach( ( item ) => {
        result[ item.slug ] = [];
      } );

      return result;
    },

  };

  const [metadata, setMetadata] = useState( Service.getDomain() );

  const [isMetadataLoading, setIsMetadataLoading] = useState(false);
  const [metadataError, setMetadataError] = useState('');

  useEffect(() => {

    let isActive = true;

    const pathname = location?.pathname || '/';

    const isPublicAuthRoute = pathname === '/login'
      || pathname === '/accept-invite'
      || pathname === '/forgot-password'
      || pathname === '/reset-password'
      || pathname === '/bootstrap-admin';


    if (loadingSession || isPublicAuthRoute) {

      setIsMetadataLoading(false);

      return () => {
        isActive = false;
      };
    }

    if (!isAuthenticated) {

      const Service = {

        getDomain: () => {
          const result = {};

          model.modules.domain.forEach( ( item ) => {
            result[ item.slug ] = [];
          } );

          return result;
        },

      };
      setMetadata( Service.getDomain() );
      setMetadataError('');
      setIsMetadataLoading(false);

      return () => {
        isActive = false;
      };
    }

    const loadMetadata = async () => {

      setIsMetadataLoading(true);
      setMetadataError('');

      try {

        const result = {};

        await Promise.all(
          model.modules.domain.map( async ( item ) => {

            const Factory = require('../../../records/modules').default;

            const response = await Factory({
              slug: item.slug
            }).Meta.getRecords({

            });

            result[ item.slug ] = response.data || [];
          } )
        );

        if (!isActive) {
          return;
        }

        setMetadata(result);
      } catch (error) {
        if (!isActive) {
          return;
        }
        setMetadataError(error?.response?.data?.message || error?.message || 'Unable to load route metadata.');
      } finally {
        if (isActive) {
          setIsMetadataLoading(false);
        }
      }
    };

    loadMetadata();

    return () => {
      isActive = false;
    };
  }, [model, isAuthenticated, loadingSession, location.pathname]);



  return (
    <Routes>

      {require( '../../../apps/meta/identity/auth' ).default( model.auth, metadata )}

      <Route
        path="/"
        element={(() => {

          const requiredRoles = [];

          if (loadingSession) {
            return <p>Checking your session...</p>;
          }

          if (!isAuthenticated) {
            return <Navigate replace state={{ from: location.pathname }} to="/login" />;
          }

          if (requiredRoles.length > 0 && !requiredRoles.includes(user?.role)) {
            return <Navigate replace to="/dashboard" />;
          }

          const App = require( '../../../app' ).default;

          return <App.Meta.Domain />;
        })()}
      >
        {require( '../../../apps/meta/identity/modules' ).default( model.modules, metadata )}
        {require( '../../../apps/meta/domain/modules' ).default( model.modules, metadata )}
        
        {require( '../../../apps/meta/domain/auth' ).default( model.auth, metadata )}

        {isMetadataLoading
          ? <Route path="*" element={<p className="error-text">Loading routes...</p>} />
          : metadataError
            ? <Route path="*" element={<p className="error-text">{`Model metadata error: ${metadataError}`}</p>} />
            : <Route path="*" element={<NotFoundPage />} />}

      </Route>

      {children}
    </Routes>
  );
}

export default Factory;